/* Noveza v2 : animations (apparition au défilement, profondeur des bandeaux).
   Désactivé si le visiteur demande « réduire les animations ». */
(function () {
  'use strict';
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var html = document.documentElement;
  html.classList.add('v2-anim');

  /* éléments qui apparaissent en glissant vers le haut, par groupe pour le décalage */
  var TARGETS = [
    '.v2-head',
    '.v2-kicker',
    '.v2-catgrid__tile',
    '.v2-tile',
    '.v2-feature__media',
    '.v2-feature .v2-card',
    '.v2-sec .v2-card',
    '.v2-guide__tx > *',
    '.v2-guide__media',
    '.v2-hero:not(.v2-hero--first) .v2-hero__in',
    '.v2-crumbs',
    '.v2-cat__title',
    '.v2-intro',
    '.v2-chip',
    '.v2-pop',
    '.v2-bar',
    '.mbtb-pdp__title',
    '.mbtb-pdp__price',
    '.mbtb-pdp__buy'
  ];

  function mark(root) {
    var seen = new Map();
    TARGETS.forEach(function (sel) {
      [].forEach.call((root || document).querySelectorAll(sel), function (el) {
        if (el.classList.contains('v2-rv') || el.closest('[data-v2-grid]')) return;
        var parent = el.parentElement;
        var n = seen.get(parent) || 0;
        seen.set(parent, n + 1);
        el.style.setProperty('--rvd', Math.min(n, 5) * 90 + 'ms');
        el.classList.add('v2-rv');
        io.observe(el);
      });
    });
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

  /* profondeur : l'image des bandeaux se déplace un peu moins vite que la page */
  var heroes = [];
  var ticking = false;
  function measure() {
    var vh = window.innerHeight;
    heroes.forEach(function (h) {
      var r = h.getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) return;
      var progress = ((r.top + r.height / 2) - vh / 2) / vh; /* -1 … 1 */
      h.style.setProperty('--py', (progress * -36).toFixed(1) + 'px');
    });
    ticking = false;
  }
  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(measure); }
  }

  function start() {
    mark(document);
    heroes = [].slice.call(document.querySelectorAll('.v2-hero--sk .v2-hero__media'));
    if (heroes.length) {
      document.addEventListener('scroll', onScroll, { passive: true, capture: true });
      window.addEventListener('resize', onScroll);
      measure();
    }
    /* sécurité : rien ne reste invisible si l'observateur ne se déclenche pas */
    setTimeout(function () {
      [].forEach.call(document.querySelectorAll('.v2-rv:not(.is-in)'), function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-in');
      });
    }, 1800);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
